// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c3e71f4","453":"ab55ca56","455":"8a3d05c3"}[chunkId] + ".chunk.js";
};